import { render, staticRenderFns } from "./NewSchool.vue?vue&type=template&id=a97e40e4&scoped=true&"
import script from "./NewSchool.vue?vue&type=script&lang=js&"
export * from "./NewSchool.vue?vue&type=script&lang=js&"
import style0 from "./NewSchool.vue?vue&type=style&index=0&id=a97e40e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97e40e4",
  null
  
)

export default component.exports